export class PasswordExpiredError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "Password Expired";
  }
}
